import OfferTermRow from './OfferTermRow'

export default OfferTermRow
